export default {
    gaEnable: process.env.MIX_GA_ENABLE,
    appDebug: process.env.MIX_APP_DEBUG,
    mixGaId: process.env.MIX_GA_ID,
    bx24MigrationFromLegacyEnabled: (process.env.MIX_BX24_MIGRATION_FROM_LEGACY_ENABLED === 'true'),
    vueDevSaasOff: (process.env.MIX_VUEDEV_SAAS_OFF === 'true'),
    vueDevFrameOff: (process.env.MIX_VUEDEV_FRAME_OFF === 'true'),
    preserveBx24Title: (process.env.MIX_PRESERVE_BX24_TITLE === 'true'),
};
